module.exports = __webpack_public_path__ + "img/biao2.3cd64855.png";